import styled from '@emotion/styled';
import { scrollbar } from 'shared/styles/scrollbar';
import { theme } from 'styles/theme/theme';

/**
 * Ширина бокового меню: 20% окна, но не уже 289px и не шире 360px. Без верхнего предела на
 * широком мониторе меню разъезжалось до ~700px, а подписи и значки пунктов терялись в пустоте.
 * 360px — максимальная ширина навигационного drawer в Material 3 (`DrawerDefaults.MaximumDrawerWidth`).
 * Одно значение на меню, шапку и контент — иначе они разъедутся.
 */
const MENU_WIDTH = 'clamp(289px, 20%, 360px)';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.SurfaceCultured10};
`;

export const Menu = styled.menu`
  position: fixed;
  top: 0;
  left: 0;
  width: ${MENU_WIDTH};
  height: 100vh;
  background: ${({ theme }) => theme.colors.SurfaceIndependence40};
  /* Меню перекрывает шапку — так было и в паре 8000/7999. */
  z-index: ${({ theme }) => theme.zIndex.sticky + 1};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: ${MENU_WIDTH};
  right: 0;
  height: 70px;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  z-index: ${({ theme }) => theme.zIndex.sticky};
  border: 1px solid #1a1a291a;
  border-radius: 0 0 8px 8px;
  padding: 0 24px;
  margin-inline: 24px;

  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    left: 0;
    height: 56px;
    margin-inline: 12px;
    padding: 0 12px;
  }
`;

export const MainBlockWrapper = styled.div`
  margin-top: 70px;
  margin-left: ${MENU_WIDTH};
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: calc(100% - ${MENU_WIDTH});
  //min-height: 100vh;
  min-height: calc(100vh - 70px);

  @media (max-width: 768px) {
    margin-top: 56px;
    margin-left: 0;
    width: 100%;
    min-height: 100vh;
    //min-height: calc(100vh - 56px);
  }
`;

export const Content = styled.div`
  flex: 1;
  overflow: auto;
  ${scrollbar(theme)}
`;

export const Footer = styled.div`
  height: 70px;
  display: flex;
  background-color: ${({ theme }) => theme.colors.SurfaceCultured10};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BurgerButton = styled.button`
  display: none;
  @media (max-width: 768px) {
    display: inline-flex;
  }
  align-items: center;
  justify-content: center;
  /* Без этого в тесной шапке (заголовок + кнопки) бургер сжимался до иконки. */
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #1a1a291a;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  color: ${({ theme }) => theme.colors.DarkBlue};
`;

export const MobileMenuOverlay = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: ${({ theme }) => theme.zIndex.modal};
`;

export const MobileMenuPanel = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: min(85vw, 320px);
  background: ${({ theme }) => theme.colors.SurfaceIndependence40};
  /* Панель мобильного меню — поверх собственного затемнения. */
  z-index: ${({ theme }) => theme.zIndex.modal + 1};
  overflow-y: auto;
`;
